// extracted by mini-css-extract-plugin
export default {"buttonContainer":"registered-offers_buttonContainer__jRNx+","input":"registered-offers_input__tRWWX"};